<mat-card class="card">
  <mat-card-header>
    <h3 mat-card-title>
      {{ 'Metadata' | translate }}
    </h3>
  </mat-card-header>
  <mat-card-content>
    <p>{{ 'Audit ID' | translate }}: {{ log.audit_id || '-' }}</p>
    <p>{{ 'Version' | translate }}: {{ log.service_data.vers.major ? ('Major' | translate) : ('Minor' | translate) }}</p>
    <p>{{ 'Session' | translate }}: {{ log.session || '-' }}</p>
  </mat-card-content>
</mat-card>
